import BaseSingleton from '../base/base_singleton';
import ServiceFactory from './service_factory';


export default class ServicesRegistry extends BaseSingleton {

    static CLASS = 'ServicesRegistry';

    _services: any = {};

    registerService(servicePrototype: any) : void    {
        this._services[servicePrototype.CLASS] = {
            servicePrototype: servicePrototype
        };
    }

    getService(className: string): any {
        let serviceDescriptor = this._services[className];
        if (!serviceDescriptor) {
            this.throwError('20', 'There is no registered service with CLASS ' + className, null);
        }
        let serviceInstance = serviceDescriptor.servicePrototype.create();
        if(!serviceDescriptor.dependenciesInjected) {
            serviceInstance.injectDependencies({
                createServiceFactoryFunction: () => ServiceFactory.create({})
            });
            serviceDescriptor.dependenciesInjected = true;
        }
        return serviceInstance;
    }
}

